import React from 'react';
import classnames from 'classnames';
import WordmarkIcon from 'images/icons/logos/wordmark.svg?react-svg';
import { MutedBackground } from 'scy/Background';
import { Body } from 'scy/text';
import { accent } from 'scy/text/styles.mod.scss';
import { textCenter } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function GiftClaimHeader({ className }) {
  return (
    <MutedBackground
      tag="header"
      className={classnames(className, textCenter, padding.sm)}
    >
      <WordmarkIcon className={`${accent} ${margin.bottom_xs}`} />
      <Body>Beer, Wine & Spirits Delivered</Body>
    </MutedBackground>
  );
}
